import { render, staticRenderFns } from "./ClassCard.vue?vue&type=template&id=f694cc76&scoped=true&"
import script from "./ClassCard.vue?vue&type=script&lang=js&"
export * from "./ClassCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f694cc76",
  null
  
)

export default component.exports